import { PublicProfileState } from './State'

import { GET_USER_PROFILE, PublicProfileAction } from './Actions'

function publicProfileReducer(state: PublicProfileState, action: PublicProfileAction): PublicProfileState {
  switch (action.type) {
    case GET_USER_PROFILE:
      return Object.assign({}, state, { ...action.payload })
    default:
      return state
  }
}

export default publicProfileReducer
